let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("duE0v")).then(() => parcelRequire('fKHiY'));